import classNames from 'classnames';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { DisclaimerTrigger } from 'routes/smart-quote/components/disclaimer';
import { trackSmartQuoteEvent } from 'routes/smart-quote/utils';

export const LearnMoreWarning = ({ className, ...props }: Omit<ComponentProps<'div'>, 'children'>) => {
  const trackDisclaimer = () => {
    trackSmartQuoteEvent('disclaimer', 'open - quick start learn more');
  };

  return (
    <div
      className={classNames('alert d-flex text-secondary fs-12 p-0 py-3 mt-auto gap-2', className)}
      role="alert"
      {...props}
    >
      <em className="icon icon-outlined fs-16 lh-1">info</em>
      <span>
        <FormattedMessage
          id="smartQuote.workspace.promptConfigurator.learnMoreWarning.text"
          values={{
            learnMore: (chunks: React.ReactNode) => (
              <DisclaimerTrigger>
                <a role="button" className="alert-link text-nowrap" onClick={trackDisclaimer}>
                  {chunks}
                </a>
              </DisclaimerTrigger>
            ),
          }}
        />
      </span>
    </div>
  );
};
